import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import ContactForm from './ContactForm';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import heroImg from '../../images/help_support_v2.jpg';
import shopRangerBanner from '../../images/shop_a_ranger_v2.jpg';

const bgStyle = {
  backgroundImage: `url(${heroImg})`
};

const bgShopRangerStyle = {
  backgroundImage: `url(${shopRangerBanner})`
};

const shopRangerUrl = `https://shop.sdacford.com.my/vehicle`;

import { fetchFaqs } from '../../actions/faq';

import { clearApiError } from '../../actions/api';

import { SITE_TITLE } from '../../constants';

class Help extends Component {
  constructor(props) {
    super(props);
    this.initData = this.initData.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    if (this.props.faqs.length < 1) {
      this.initData();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchFaqs } = this.props;
    await fetchFaqs();
  }

  render() {
    const { loading, error, faqs, t } = this.props;
    if (error) {
      return <ErrorDisplay error={error} />;
    }
    if (loading) {
      return <LottieLoader />;
    }
    return (
      <>
        <Helmet>
          <title>
            {t('support:title')} | {SITE_TITLE}
          </title>
        </Helmet>
        <div className='fe-hero-container fe-under-header-effect-except-mobile'>
          <div className='fe-hero-img' style={bgStyle} />
        </div>
        <article className='fe-help'>
          <div className='container'>
            <div className='row justify-content-lg-center'>
              <div className=''>
                <section className='fe-help-support section-center'>
                  <h1 className='fe-heading'>{t('support:title')}</h1>
                  <p
                    className='fe-help-hotline section-center'
                    dangerouslySetInnerHTML={{
                      __html: t('support:subText')
                    }}
                  />
                  {/* <div className='fe-help-hotline'>1-800-18-1828</div> */}
                  {/* <div className='fe-help-hotline'>
                    <a href='https://wa.me/60192041200' target='_blank'>
                      WhatsApp Chat @ 019-2041200
                    </a>
                  </div> */}
                </section>
                {/* <section className='fe-help-contact'>
                  <h1 className='fe-heading'>{t('support:leaveMessage')}</h1>
                  <p>{t('support:contactText')}</p>
                  <ContactForm />
                  <p>{t('support:interestInVehicle')}</p>
                  <div className='fe-shop-ranger-container'>
                    <div
                      className='fe-shop-ranger-banner'
                      style={bgShopRangerStyle}
                      onClick={() => window.open(shopRangerUrl, '_blank')}
                    />
                  </div>
                </section> */}
              </div>
            </div>
          </div>
        </article>

        {/* <section className='fe-help-banner'>
          <img src={shopRangerBanner} alt='' />
        </section> */}
      </>
    );
  }
}

Help.propTypes = {
  faqs: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  fetchFaqs: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ faqState, apiState }) => ({
  faqs: faqState.faqs,
  loading: faqState.loading,
  error: apiState.error
});

const mapDispatchToProps = {
  fetchFaqs,
  clearApiError
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Help)
);
